import { merge } from 'lodash/fp';
import commonInitialValues from '../common/initialValues';

const initialValues = merge(
    commonInitialValues,
    {
        taxRegime: 'privateRentalNew',
        managementFees: 0.09,
        guaranteedIncome: 0.023,
        rentalFees: 0.0185,
        rentsIndexation: 0.02,
    },
);

export default initialValues;
